import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translations
import enTranslations from '../locales/en/common.json';
import ruTranslations from '../locales/ru/common.json';

const resources = {
  en: {
    translation: enTranslations
  },
  ru: {
    translation: ruTranslations
  }
};

i18n
  .use(LanguageDetector) // Detect user language
  .use(initReactI18next) // Pass i18n instance to react-i18next
  .init({
    resources,
    fallbackLng: 'en', // Default language
    lng: localStorage.getItem('i18nextLng') || 'ru', // Get saved language or default to Russian

    interpolation: {
      escapeValue: false, // React already escapes values
      prefix: '{{',
      suffix: '}}'
    },

    detection: {
      // Order and from where user language should be detected
      order: ['localStorage', 'navigator'],
      // Cache user language
      caches: ['localStorage'],
      // Keys to store language in localStorage
      lookupLocalStorage: 'i18nextLng'
    }
  });

export default i18n;
